//
// List anchors sticky nav - active section detection on scroll
// https://codepen.io/rishabhp/pen/aNXVbQ
//
// https://css-tricks.com/smooth-scrolling-accessibility/
//
var fn_list_anchors = function () {

    if ($('.content-list-anchors__wrapper').length > 0) {

        var sectionsParent = $('.row-main-directory'),
            sections = $('.content-region__wrapper'),
            anchorNav = $('.content-list-anchors__wrapper'),
            navHeight = $('.masthead__wrapper').outerHeight(); // was 60; // sticky height is 60px


        // Limits for sticky
        var beginStickyPosition = anchorNav.offset().top + anchorNav.outerHeight()*0.5 - $(window).outerHeight()*0.5;
        var endStickyPosition = sectionsParent.offset().top + sectionsParent.outerHeight();

        $(window).on('scroll', function () {
            var scrollTopPosition = $(this).scrollTop();
            var stickyBottomPosition = scrollTopPosition + anchorNav.outerHeight()*0.5 + $(window).outerHeight()*0.5;

            //
            // Active section detection
            //
            sections.each(function () {
                var sectionTop = $(this).offset().top - navHeight,
                    sectionBottom = sectionTop + $(this).outerHeight();

                if (scrollTopPosition >= sectionTop && scrollTopPosition <= sectionBottom) {
                    anchorNav.find('a').removeClass('is-active');
                    anchorNav.find('a[href="#' + $(this).attr('id') + '"]').addClass('is-active');
                }
            });

            //
            // Sticky gestion
            //
            if (scrollTopPosition >= beginStickyPosition && stickyBottomPosition < endStickyPosition) {
                anchorNav.addClass('is-fixed');
                anchorNav.removeClass('position-init');
                anchorNav.removeClass('was-fixed');
            } else if (stickyBottomPosition >= endStickyPosition) {
                anchorNav.addClass('was-fixed');
                anchorNav.removeClass('is-fixed');
                anchorNav.removeClass('position-init');
            } else {
                // inital position
                anchorNav.removeClass('is-fixed');
                anchorNav.removeClass('was-fixed');
            }

        });

        anchorNav.find('a').on('click', function () {
            var $el = $(this),
                id = $el.attr('href');

            var target = $(this.hash);

            $('html, body').animate({
                scrollTop: $(id).offset().top
            }, 500);

            target.focus(); // Setting focus

            if (target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                target.focus(); // Setting focus
            }

            return false;
        });

    }

};
